import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { ArrowLeft } from "lucide-react";

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream p-4 md:p-8">
      <div className="max-w-4xl mx-auto">
        <Button
          onClick={() => navigate(-1)}
          variant="ghost"
          className="mb-6 flex items-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </Button>

        <Card>
          <CardHeader>
            <CardTitle className="text-3xl text-burgundy">Terms of Service</CardTitle>
            <p className="text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>
          </CardHeader>
          <CardContent className="prose prose-burgundy max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">1. Acceptance of Terms</h2>
              <p className="text-gray-700">
                By accessing and using Luminelle Wellness ("the Service"), you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">2. Use License</h2>
              <p className="text-gray-700 mb-2">
                Permission is granted to temporarily access the materials (information or software) on Luminelle Wellness for personal, non-commercial transitory viewing only.
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose</li>
                <li>Attempt to decompile or reverse engineer any software contained on the Service</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">3. User Accounts</h2>
              <p className="text-gray-700">
                You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">4. Medical Disclaimer</h2>
              <p className="text-gray-700">
                The information provided on Luminelle Wellness is for educational and informational purposes only. It is not intended as medical advice and should not be used to diagnose, treat, cure, or prevent any disease or condition. Always consult with a qualified healthcare provider before making any healthcare decisions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">5. Community Guidelines</h2>
              <p className="text-gray-700 mb-2">
                Users must maintain respectful communication and adhere to community standards:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>No harassment, hate speech, or discriminatory language</li>
                <li>No spam or unauthorized advertising</li>
                <li>Respect privacy and confidentiality of other members</li>
                <li>Do not share medical advice or personal medical information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">6. Subscription & Payments</h2>
              <p className="text-gray-700">
                Subscription fees are billed in advance on a recurring basis. You may cancel your subscription at any time through your account settings. Refunds are handled on a case-by-case basis.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">7. Termination</h2>
              <p className="text-gray-700">
                We reserve the right to terminate or suspend access to our Service immediately, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">8. Changes to Terms</h2>
              <p className="text-gray-700">
                We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-burgundy mb-3">9. Contact Information</h2>
              <p className="text-gray-700">
                For questions about these Terms of Service, please contact us through the Support section in your dashboard.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
